module.exports = __webpack_public_path__ + "img/logoBranco.8cd72f2d.png";